import React from 'react';
import cx from 'classnames';

import sharedLpStyles from '~/styles/landingPageShared.module.less';
import styles from './CardsSection.module.less';

type CardsSectionProps = {
  children: JSX.Element[];
};

const CardsSection: React.FC<CardsSectionProps> = ({ children }): JSX.Element => (
  <div className={cx(sharedLpStyles.outer, styles.lightGrayBg)}>
    <div
      className={cx(
        sharedLpStyles.sectionContainer,
        sharedLpStyles.maxWidth,
        styles.cardsContainer
      )}
    >
      {children}
    </div>
  </div>
);

export default CardsSection;
